/**
 * Keyboard accessibility for CSS hover dropdowns in the main navbar:
 * syncs aria-expanded on the trigger link (desktop only, where the CSS
 * :hover/:focus-within rules apply) and closes on Escape without the
 * .dropdown-esc-closed guard class letting :focus-within reopen the menu.
*/

const navDropdownA11y = (() => {

  const mqDesktop = window.matchMedia('(min-width: 992px)');

  document.querySelectorAll('.navbar-nav .nav-item.dropdown').forEach((li) => {
    const link = li.querySelector('a.nav-link');
    const menu = li.querySelector(':scope > .dropdown-menu');

    if (link == null || menu == null || li.querySelector('[data-bs-toggle="dropdown"]') != null) return;

    const sync = () => {
      mqDesktop.matches ? link.setAttribute('aria-expanded', 'false') : link.removeAttribute('aria-expanded');
    };
    sync();
    mqDesktop.addEventListener('change', sync);

    const open = () => {
      if (!mqDesktop.matches) return;
      li.classList.remove('dropdown-esc-closed');
      link.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      if (mqDesktop.matches) link.setAttribute('aria-expanded', 'false');
    };

    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', () => {
      li.classList.remove('dropdown-esc-closed');
      if (!li.contains(document.activeElement)) close();
    });
    li.addEventListener('focusin', () => {
      if (!li.classList.contains('dropdown-esc-closed')) open();
    });
    li.addEventListener('focusout', (e) => {
      if (!li.contains(e.relatedTarget)) {
        li.classList.remove('dropdown-esc-closed');
        close();
      }
    });
    li.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || link.getAttribute('aria-expanded') !== 'true') return;
      e.stopPropagation();
      li.classList.add('dropdown-esc-closed');
      close();
      link.focus();
    });
  });

})();

export default navDropdownA11y;
